import { useState } from 'react';

/* CSS */
import styles from './StatCard.module.css';
import shared from '../../styles/shared.module.css';

/* Icons */
import info_icon from '../../assets/icons/info_icon.svg';

/* Cards */
import StatDetailOverlay from './StatDetailOverlay.js';

const StatCard = ({ label, value, icon, info, note, className = "", centered = false, iconStyle = {}, children, back }) => {
    // When `centered` is set and there's no image (empty state), vertically center the
    // value/note while keeping the label pinned at its usual bottom position.
    const centerBottom = centered && !children;

    const [isOpen, setIsOpen] = useState(false);
    const interactive = !!back;

    const cardBody = (
        <>
            <div className={styles.statTop}>
                <img src={icon} alt={label} className={styles.statIcon} style={iconStyle} />
                <div className={shared.infoIconWrapper} data-tooltip={info}>
                    <img src={info_icon} alt={`Statistics for ${label}`} className={shared.infoIcon} />
                </div>
            </div>

            {/* Image if applicable */}
            {children}

            <div className={styles.statValueContainer}>
                <span className={styles.statValue}>{value}</span>
                {note &&
                    <span className={styles.statNote}>
                        {note}
                    </span>
                }
            </div>
            <div className={`${styles.statLabel} ${centerBottom ? styles.centered : ''}`}>{label}</div>
        </>
    )

    return (
        <>
            <div
                className={`${styles.statCard} ${className} ${interactive ? styles.clickable : ''}`}
                role={interactive ? 'button' : undefined}
                tabIndex={interactive ? 0 : undefined}
                onClick={interactive ? () => setIsOpen(true) : undefined}
                onKeyDown={interactive ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setIsOpen(true);
                    }
                } : undefined}
            >
                {cardBody}
            </div>

            {interactive && isOpen &&
                <StatDetailOverlay
                    label={label}
                    front={cardBody}
                    back={back}
                    info={info}
                    onClose={() => setIsOpen(false)}
                />
            }
        </>
    );
};

export default StatCard;
